import styled from 'styled-components';

export const StyledPatientPhoneNotificationForm = styled.form`
   display: flex;
   flex-direction: column;
   gap: 24px;
   max-width: 900px;
`;

StyledPatientPhoneNotificationForm.displayName = 'StyledPatientPhoneNotificationForm';
